// This file is auto-generated by @hey-api/openapi-ts

export const ValidityFilterEnum = {
    PAST: 'PAST',
    PRESENT: 'PRESENT',
    FUTURE: 'FUTURE',
    PRESENT_OR_FUTURE: 'PRESENT_OR_FUTURE'
} as const;

export type ValidityFilterEnum = typeof ValidityFilterEnum[keyof typeof ValidityFilterEnum];
